//@ts-check
import * as THREE from "three";
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter.js';

/**
 * @module Utilities
 */


/**
 * Parse Hex Color to THREE.Color
 * @param {Number} color Hex color
 * @returns {THREE.Color} Returns Three Color
 */
export function parseColor(color) {
  let value = color;
  if (this.isObject(color)) value = color.hex;
  return new THREE.Color(this.toHex(value));
}

/**
 * Parse string to hex Color
 * @param {String} hex 
 * @returns returns Hex Color
 */
export function toHex(hex) {

  var output = hex.toString();
  if (hex.slice(0, 1) === "#") {
    output = hex.substring(1);
  }
  output = output.slice(0, 6);
  if (hex.slice(0, 2) !== "0x") {
    output = "0x" + output;
  }
  output = output.toLowerCase();
  return parseInt(output, 16);
}

/**
 * Exports this.scene (THREE.OBJECT3D) to string 
 * @returns {string} Parsed THREE Scene Object.3D
 */
export function toObjString() {

  const exporter = new OBJExporter();
  const result = exporter.parse(this.scene);

  return result;
}
/**
 * Returns the value to expression to take power of scope.digits
 * @param {Object} value 
 * @returns {Number} 
 */
export function setDigits(value) {
  const factor = Math.pow(10, this.digits);
  let val = value;
  if (!isNaN(value)) val = Math.round(value * factor) / factor;
  return val;
}

/**
 * Updates the azimuth angle
 * @param {Number} azimuthVal 
 * @returns {Object} Return success or error messages 
 */
export function updateAzimuth(azimuthVal) {
  var scope = this;
  try {
    if (azimuthVal >= 0.0 && azimuthVal <= 360.0) {
      scope.azimuth = azimuthVal;
      scope.updateTheta();
      scope.setSkyPosition();
      var returnValue = {
        "status": "success",
        "message": "Azimuth angle updated successfully."
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Azimuth angle must be in between 0.0 to 360.0"
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error" + err.message
    }
    return returnValue;
  }
}


/**
 * Updates the Elevation
 * @param {Number} elevationVal Elevation va;ue value must be in between 0.0 to 180.0."
 * @returns {Object} Return success or error messages 
 */
export function updateElevation(elevationVal) {
  var scope = this;
  try {
    if (elevationVal >= 0.0 && elevationVal <= 180.0) {
      scope.elevation = elevationVal;
      scope.updatePhi();
      scope.setSkyPosition();
      var returnValue = {
        "status": "success",
        "message": "Elevation value updated successfully."
      }
      return returnValue;
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Elevation va;ue value must be in between 0.0 to 180.0."
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      "status": "failed",
      "message": "System Error: " + err.message
    }
    return returnValue;
  }
}